"use client";

import { c as _c } from "react/compiler-runtime";
import { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { Suspense, type Usable } from "react";
import type { ResolvedIntlConfig } from "react-intl";
import { LocationSelectorClient } from "#/components/molecules/global/location-selector/location-selector-client";
import { LocationSelectorClient_Localization_Fragment } from "#/components/molecules/global/location-selector/graphql";
export { LocationSelectorClient_Localization_Fragment };
export function LocationSelector(t0) {
  const $ = _c(5);
  const {
    className,
    dictionaryPromise,
    lang,
    localizationMasked
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== dictionaryPromise || $[2] !== lang || $[3] !== localizationMasked) {
    t1 = <Suspense fallback={null}><LocationSelectorClient className={className} dictionaryPromise={dictionaryPromise} lang={lang} localizationMasked={localizationMasked} /></Suspense>;
    $[0] = className;
    $[1] = dictionaryPromise;
    $[2] = lang;
    $[3] = localizationMasked;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}